<template>
  <div class='layout'>
    <!-- ommited -->
    <app-social-chat icon :attendants="attendants">
      <p slot="header">Clicquez sur un de nos représentants ci-dessous pour chatter sur Whatsapp</p>
      <template v-slot:button>
        <font-awesome-icon size="2x" :icon="['fab', 'whatsapp']"/>
      </template>
      <small slot="footer">Appelez nous au +243854737970 de 9:00 à 17:00</small>
    </app-social-chat>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import { SocialChat } from 'vue-social-chat'

export default {
  name: "SocialChat",
  props: {},
  data(){
    return{
      attendants: [
        {
          app: 'whatsapp',
          label: 'Support Marketing',
          name: 'Magalie Mofambala',
          number: '243841357775',
          avatar: {
            src: 'https://infotexto.com/profiles/magalie.jpg',
            alt: 'Magalie Mofambala avatar'
          }
        },
        {
          app: 'whatsapp',
          label: 'Support Clientèle',
          name: 'Tamio Lungela',
          number: '33758795522',
          avatar: {
            src: 'https://infotexto.com/profiles/tamio.jpg',
            alt: 'Tamio Lungela avatar'
          }
        },
        {
          app: 'whatsapp',
          label: 'Support Technique',
          name: 'Ridi Luamba',
          number: '243854737970',
          avatar: {
            src: 'https://infotexto.com/profiles/ridi.jpg',
            alt: 'Ridi Luamba avatar'
          }
        },
      ]
    }
  },
  components: {
    AppSocialChat: SocialChat
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([]),
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}

}
</script>

<style lang="scss" scoped>
@media (min-width: 576px) {}

@media (min-width: 768px) {}

@media (min-width: 992px) {}
</style>



// WEBPACK FOOTER //
// src/components/shared/SocialChat.vue